import { getBffRequest } from "./base/api";
import {
	GetClaimsBffVersionRequest,
	GetClaimsBffVersionResponse,
	GetStatesRequest,
	GetStatesResponse
} from "./protos/messages/core.message_pb";
import { getApiToken } from "../helpers";

export const getStatesList = async (): Promise<GetStatesResponse> => {
	const token = getApiToken();
	const request = new GetStatesRequest();
	const client = getBffRequest(token);

	return client
		.getStates(request, {})
		.then((response: GetStatesResponse) => {
			return response;
		})
		.catch((err) => {
			console.error("Failed to get states list:", err);
			throw err;
		});
};

export const getClaimsBFFVersion = async (): Promise<GetClaimsBffVersionResponse> => {
	const token = getApiToken();
	const request = new GetClaimsBffVersionRequest();
	const client = getBffRequest(token);

	return client
		.getClaimsBffVersion(request, {})
		.then((response: GetClaimsBffVersionResponse) => {
			return response;
		})
		.catch((err) => {
			console.error("Failed to get Claims BFF version:", err);
			throw err;
		});
};
